import styled from "styled-components"

const ActuAdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const ActualiteTags = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const ActuFooterBack = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const ActuFooterDate = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const ActuTaxo = styled.span`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export {
  ActuAdditionalInfos,
  ActualiteTags,
  ActuFooterBack,
  ActuFooterDate,
  ActuTaxo,
}
